import { render, staticRenderFns } from "./BoxeDetails.vue?vue&type=template&id=d5073822&scoped=true&"
import script from "./BoxeDetails.vue?vue&type=script&lang=js&"
export * from "./BoxeDetails.vue?vue&type=script&lang=js&"
import style0 from "./BoxeDetails.vue?vue&type=style&index=0&id=d5073822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5073822",
  null
  
)

export default component.exports